import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ModalLeerPlantilla = ({ isOpen, toggle, selectedPlantilla }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Ver Plantilla</ModalHeader>
            <ModalBody>
                {selectedPlantilla ? (
                    <div>
                        <h5>Nombre: {selectedPlantilla.name}</h5>
                        <h6>Contenido:</h6>
                        <div style={{ border: '1px solid #ccc', padding: '10px', maxHeight: '400px', overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: selectedPlantilla.content }}>
                        </div>
                    </div>
                ) : (
                    <p>No se ha seleccionado una plantilla.</p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerPlantilla;